export default {
  isJSONString(str) {
    if (typeof str === 'string') {
      try {
        const obj = JSON.parse(str);
        if (typeof obj === 'object' && obj) {
          return true;
        } else {
          return false;
        }
      } catch {
        return false;
      }
    } else {
      return false;
    }
  },
  isPhoneNumber(value) {
    const val = value.toString();
    if (val.match(/^(0|86|17951)?(1[3-9][0-9])[0-9]{8}$/)) {
      return true;
    } else {
      return false;
    }
  }
}